import React from 'react';
import { makeStyles } from 'tss-react/mui';
import ContextMenuItem from './ContextMenuItem';
const useStyles = makeStyles()(theme => {
    return {
        contextMenuItemGroup: {
            '&:not(:empty)': {
            // padding: `${theme.spacing(2)} 0`
            },
            '& + &:not(:empty)': {
                borderTop: `1px solid ${theme.palette.ui04}`
            },
            '&:first-of-type': {
                paddingTop: 0
            },
            '&:last-of-type': {
                paddingBottom: 0
            },
            '& .toolbar-button-with-badge': {
                width: '100%',
                height: '32px'
            }
        },
        contextMenuItemGroupWhite: {
            '& + &:not(:empty)': {
                borderTop: `1px solid ${theme.palette.ui07}`
            },
        }
    };
});
const ContextMenuItemGroup = ({ actions, children, className, whiteUI = false, }) => {
    const { classes: styles, cx } = useStyles();
    return (React.createElement("div", { className: cx(styles.contextMenuItemGroup, whiteUI && styles.contextMenuItemGroupWhite, className) },
        children,
        actions?.map(actionProps => (React.createElement(ContextMenuItem, { key: actionProps.text, ...actionProps, whiteUI: whiteUI })))));
};
export default ContextMenuItemGroup;
